@use 'src/globals/main';

pn-accordion-row {
  position: relative;
  margin: 0 -0.25em 0;
}

pn-accordion-row .pn-accordion-row {
  width: 100%;
  display: flex;
  flex-direction: column;

  &-summary {
    color: main.$gray900;
    position: relative;
    border: none;
    outline: 0;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;

    width: 100%;
    padding: 0.25em;
    font-size: 1em;
    font-weight: 400;
    border-radius: 0.5em;

    list-style: none;

    &:hover > .pn-accordion-row-text {
      background-color: main.$blue50;
    }

    &:focus-visible > .pn-accordion-row-text {
      @include main.pn-focus-visible();
    }

    &::-webkit-details-marker {
      display: none;
    }
  }

  &-text {
    position: relative;
    overflow: hidden;
    display: flex;
    align-items: center;
    padding: 0.75em;
    background-color: main.$white;
    border-radius: 0.5em;
    -webkit-tap-highlight-color: transparent;

    &[data-transparent] {
      background-color: transparent;
    }

    @include main.pn-focus-base();
    @include main.pn-transition('background-color, outline-color');
    @include main.pn-ripple(main.$blue700);
  }

  &-icon {
    margin-left: auto;
    flex-shrink: 0;
    @include main.pn-transition('transform');
    path {
      fill: main.$blue700;
    }
  }

  &[open] .pn-accordion-row-icon {
    transform: rotate(-180deg);
  }

  &-content {
    color: main.$gray900;
    display: block;
    padding: 1em;
  }
}
